// Helper to determine whether an individual error should be downgraded in our monitoring system
// The location of the error message is not consistent so we need to manually check between a few different fields
import { TransactionExecutionError } from 'viem';

export const shouldDowngradeError = (error: unknown) => {
  if (!error) return false;

  if (!(error instanceof TransactionExecutionError)) return false;
  const { shortMessage, details } = error;

  if (shortMessage?.includes('does not match the target chain')) return true;

  if (details?.includes('Your app has exceeded its concurrent requests capacity')) return true;
  if (details?.includes('request too fast per second')) return true;
  if (details?.includes('Ledger device: Condition of use not satisfied')) return true;
  if (details?.includes('Please enable Blind signing or Contract data')) return true;
  if (details?.includes('Request rejected')) return true;
  // Details here can either be lowercase or upper case cancelled with no other info
  if (details?.toLowerCase() === 'cancelled') return true;
  if (details?.includes('Failed to sign')) return true;
  if (details?.includes('No keyring found')) return true;
  if (details?.includes('MetaMask is having trouble connecting to the network')) return true;
  if (details?.includes('nonce too low')) return true;
  if (details?.includes('Failed to fetch')) return true;
  if (details?.includes('Transaction is underpriced')) return true;
  if (details?.includes('already known')) return true;

  return false;
};
